import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { ErrorAlert } from '@/components/ErrorAlert';
import { LoadingIcon } from '@/components/LoadingIcon';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AiPhoneCallsTable } from '@/features/ai-phone-calls/AiPhoneCallsTable';

export const Route = createFileRoute('/a/phone-calls')({
  staticData: {
    breadcrumbs: [{ label: 'Phone calls' }],
  },
  component: AdminPhoneCallListPage,
});

/** Every venue's latest AI phone calls, live ones updating as the agent takes the order. */
function AdminPhoneCallListPage() {
  const callsQuery = useQuery(api.aiPhone.listRecentCalls);
  if (callsQuery.isPending) return <LoadingIcon />;
  if (callsQuery.isError) {
    return <ErrorAlert title="Error loading phone calls" message={callsQuery.error.message} />;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Phone calls</CardTitle>
        <CardDescription>
          The latest calls to every venue's AI phone number. Open one to follow it live.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <AiPhoneCallsTable calls={callsQuery.data} showRestaurantColumn />
      </CardContent>
    </Card>
  );
}
